import React, { FC, useState } from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { Event, KeyboardArrowDown } from '@mui/icons-material';

type Props = {
  nextSectionLabel?: string;
  onNextSection?: () => void;
  twinkle?: boolean;
  skipLabel?: string;
  onSkip?: () => void;
};

const twinkleStyles = `
  @keyframes twinkle {
    0% { transform: translateX(-100%) skewX(-15deg); }
    100% { transform: translateX(300%) skewX(-15deg); }
  }
`;

export const SectionCTA: FC<Props> = ({ nextSectionLabel, onNextSection, twinkle: showTwinkle, skipLabel, onSkip }) => {
  const [loading, setLoading] = useState(false);

  const handleBookCall = () => {
    //@ts-ignore
    window.lintrk?.('track', { conversion_id: 11423801 });
    setLoading(true);
    setTimeout(() => {
      window.open('https://meetings.hubspot.com/my11', '_blank');
      setLoading(false);
    }, 2000);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5, mt: 3, mb: 2 }}>
      {showTwinkle && <style>{twinkleStyles}</style>}
      <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
      {skipLabel && onSkip && (
        <Button
          variant="contained"
          size="large"
          onClick={onSkip}
          sx={{
            textTransform: 'none',
            backgroundColor: 'rgba(150,150,150,0.2)',
            color: 'rgba(255,255,255,0.7)',
            '&:hover': { backgroundColor: 'rgba(150,150,150,0.35)' },
          }}
        >
          {skipLabel}
        </Button>
      )}
      <span style={{ position: 'relative', display: 'inline-block', overflow: 'hidden', borderRadius: 4 }}>
        <Button
          color="secondary"
          variant="contained"
          size="large"
          style={{ textTransform: 'none' }}
          startIcon={loading ? <CircularProgress style={{ width: 24, height: 24 }} /> : <Event />}
          onClick={handleBookCall}
          disabled={loading}
        >
          Book a Call
        </Button>
        {showTwinkle && (
          <span style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '40%',
            height: '100%',
            background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
            pointerEvents: 'none',
            transform: 'translateX(-100%) skewX(-15deg)',
            animation: 'twinkle 0.6s 1.2s ease-in-out forwards',
          }}/>
        )}
      </span>
      </Box>
      {nextSectionLabel && onNextSection && (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0 }}>
          <Button
            size="large"
            onClick={onNextSection}
            sx={{
              textTransform: 'none',
              color: 'rgba(150,150,150,0.7)',
              '&:hover': { color: 'rgba(150,150,150,1)' },
              pb: 0,
            }}
          >
            {nextSectionLabel}
          </Button>
          <KeyboardArrowDown sx={{ color: 'rgba(150,150,150,0.7)', mt: -0.5 }}/>
        </Box>
      )}
    </Box>
  );
};
